import { generateLazyContextProvider } from './LazyContext';
import { LazyUsersContext, TLazyUserInfo } from './LazyUsersContext';
import { apiUser } from '../resources/api/apiUser';

const { useGetUsersByIdsSilent } = apiUser;

export const LazyUsersContextProvider = generateLazyContextProvider(
  LazyUsersContext,
  (user: TLazyUserInfo) => user.id,
  () => useGetUsersByIdsSilent().execute
);
